import { render, staticRenderFns } from "./code-cell.vue?vue&type=template&id=5bd54394&scoped=true"
import script from "./code-cell.vue?vue&type=script&lang=js"
export * from "./code-cell.vue?vue&type=script&lang=js"
import style0 from "./code-cell.vue?vue&type=style&index=0&id=5bd54394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd54394",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/code/code-cell.vue
// module id = null
// module chunks = 